/**
 * 手続きセッションの制限時間（ソース管理）。 issue #2992 / 報告書 §8 No.9
 *
 * ■ 変更前の挙動（2026-08-31 本番負荷テスト後に確認・docs/99 隠れ仕様 #27）
 *   30 分は「操作なし」ではなく **プランページ到達からの絶対時間**だった
 *   （`planData.timestamp` は `PlanSelectTop` で 1 回だけ設定される）。
 *   混雑時は各画面の待ちが延びるため、**普通に操作していても打ち切られる**。
 *   さらに alert の文言は「しばらく操作がなかったため」で、実装と一致していなかった。
 *
 * ■ 変更後
 *   - `idleMinutes` … **最後の操作からの経過**。`checkSession` を通るたびに更新（スライド方式）。
 *   - `maxMinutes`  … 手続き開始からの**絶対上限**。ここだけは延びない。
 *     無制限にすると、離席したまま在庫を抱え続ける利用者が出るため。
 *
 * ■ 発売日の運用
 *   混雑で待ちが延びる 9/9 は `idleMinutes` を延ばしてよい（このファイルの編集＝再デプロイ）。
 *   `maxMinutes` は在庫の抱え込みに直結するので安易に延ばさないこと。
 */
export type SessionConfig = {
  /**
   * 滞在通知（heartbeat）の間隔（分）。 issue #2992 / §2-H
   * ★プランページ以外でも送る。送らないと手続き中の利用者が同時滞在の集計から抜け、
   *   実際より空いていると誤認して入場レートが上がる。
   *   サーバー側の `heartbeatMin`（設定ドキュメント）と揃えておく。
   */
  heartbeatMinutes: number;
  /** 最後の操作からこの分数が経つと打ち切る（スライドする側） */
  idleMinutes: number;
  /** 手続き開始からの絶対上限。ここは操作しても延びない */
  maxMinutes: number;
};

export const sessionConfig: SessionConfig = {
  idleMinutes: 30,
  maxMinutes: 60,
  heartbeatMinutes: 5,
};
